import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as userSettingsService from '../services/userSettings';

const initialState = {
  isFetching: false,
  fetchingError: null,
  addingError: null,
  history: {},
  adminHistory: {},
};

const sliceName = 'userSettings';

export const fetchUserSettings = createAsyncThunk(
  `${sliceName}/fetch`,
  (args, thunkAPI) => {
    return userSettingsService.getUserSettings(args.objectName)
      .catch((error) => {
        error.clientMessage = "Can't get settings from server";
        return thunkAPI.rejectWithValue(error)
      });
  }
);

export const postUserSettings = createAsyncThunk(
  `${sliceName}/fetch`,
  (args, thunkAPI) => {
    return userSettingsService.addUserSettings(args.objectName, args.settings)
      .catch((error) => {
        error.clientMessage = "Can't add settings to server";
        return thunkAPI.rejectWithValue(error)
      });
  }
);

const userSettings = createSlice({
  name: sliceName,
  initialState,
  reducers: {},
  extraReducers: {
    [fetchUserSettings.fulfilled]: (state, action) => {
      const { objectName } = action.meta.arg;
      state.isFetching = false;
      state[objectName] = action.payload;
    },
    [postUserSettings.fulfilled]: (state, action) => {
      const { objectName } = action.meta.arg;
      state.isAdding = false;
      state[objectName] = { ...state[objectName], ...action.payload };
    },

    [fetchUserSettings.pending]: (state) => {
      state.isFetching = true;
      state.fetchingError = null;
      state.addingError = null;
    },
    [postUserSettings.pending]: (state) => {
      state.isAdding = true;
      state.fetchingError = null;
      state.addingError = null;
    },

    [fetchUserSettings.rejected]: (state, action) => {
      state.isFetching = false;
      state.fetchingError = action.payload;
    },
    [postUserSettings.rejected]: (state, action) => {
      state.isAdding = false;
      state.addingError = action.payload;
    },
  }
});

const { reducer } = userSettings;

export const settingsSelectors = {
  adminHistory: (state) => state.settings.adminHistory,
  history: (state) => state.settings.history,
  isFetching: (state) => state.settings.isFetching,
  fetchingError: (state) => state.settings.fetchingError,
  addingError: (state) => state.settings.addingError,
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/settingsSlice.js